import React from 'react';
import type { LegalSection } from '../../data/legal';
import { LegalDraftNotice } from './LegalDraftNotice';
type LegalDocumentProps = {
  sections: LegalSection[];
};
export function LegalDocument({
  sections
}: LegalDocumentProps) {
  return <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-24" data-id="element-308" data-mp="28i23ybn7kkxl">
      <div className="grid gap-12 lg:grid-cols-12" data-id="element-309" data-mp="2db508rjde8hh">
        <aside className="lg:col-span-3" data-id="element-310" data-mp="2hbp0i3z8ps7u">
          <nav aria-label="On this page" className="lg:sticky lg:top-28" data-id="element-311" data-mp="2handr28v3haa">
            <p className="text-sm font-semibold text-navy" data-id="element-312" data-mp="2ma8mg4du3407">On this page</p>
            <ol className="mt-4 space-y-2.5 border-l border-line" data-id="element-313" data-mp="2mckzc34qio6e">
              {sections.map(section => <li key={section.id} data-id="element-314" data-mp="2w8o3tfn26ywi">
                  <a href={`#${section.id}`} className="-ml-px block border-l border-transparent pl-4 text-sm text-muted transition-colors duration-150 ease-out hover:border-gold hover:text-navy" data-id="element-315" data-mp="2w7mrz8y7y8dq">
                    {section.title}
                  </a>
                </li>)}
            </ol>
          </nav>
        </aside>
        <article className="lg:col-span-8 lg:col-start-5" data-id="element-316" data-mp="39dmhev4bb1dx">
          <LegalDraftNotice data-id="element-317" data-mp="34fbaas5ej4ze" />
          <p className="mt-8 text-sm text-muted" data-id="element-318" data-mp="34gmdapr0w8pg">Last updated: [Date to be confirmed]</p>
          <div className="mt-6 space-y-12" data-id="element-319" data-mp="2zh9f58upbf7k">
            {sections.map(section => <section key={section.id} id={section.id} className="scroll-mt-28" aria-labelledby={`${section.id}-title`} data-id="element-320" data-mp="zdy6dnojmyf">
                <h2 id={`${section.id}-title`} className="font-serif text-[1.85rem] font-medium leading-tight text-navy" data-id="element-321" data-mp="3s66zdhih3m2y">
                  {section.title}
                </h2>
                <div className="mt-4 space-y-4 text-[16px] leading-relaxed text-ink" data-id="element-322" data-mp="3j50d0rt57h1s">
                  {section.paragraphs.map(paragraph => <p key={paragraph} data-id="element-323" data-mp="2bs8ew8w0vadd">{paragraph}</p>)}
                  {section.list && <ul className="space-y-2.5 pl-1" data-id="element-324" data-mp="27resjjy8a3ml">
                      {section.list.map(item => <li key={item} className="flex gap-3" data-id="element-325" data-mp="294mv2w5wu6uc">
                          <span aria-hidden="true" className="mt-[11px] h-px w-3 shrink-0 bg-gold-deep" data-id="element-326" data-mp="2e525beuway83" />
                          <span data-id="element-327" data-mp="1z7rum7q2twdf">{item}</span>
                        </li>)}
                    </ul>}
                </div>
              </section>)}
          </div>
        </article>
      </div>
    </div>;
}